import type { HolisticSummaryCategory } from '@fruitful/types';
import { useLocalSearchParams } from 'expo-router';

import { ManualAccount } from '../../../../../holistic/components/manual-accounts/ManualAccount';

export default function ManualAccountDetails() {
    const { category } = useLocalSearchParams<{
        category: HolisticSummaryCategory;
    }>();
    const { id } = useLocalSearchParams<{ id: string }>();

    return <ManualAccount accountCategory={category} accountId={id} />;
}
